export const WRITING = "/writing/"
export const SPEAKING = "/speaking/"
export const NEWSLETTER = "/newsletter/"
export const CONTACT = "/contact/"
export const ARCHIVE = "/archive/"
export const TAGS = "/tags/"
